import React, { FC, useState } from 'react'
import { useEffectOnce } from 'react-use'
import { Button } from 'transfix-ui/components/Button'
import { Toast } from 'transfix-ui/components/Toast'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import * as Types from 'apps/fleet-planner/types'
import { SETTINGS_TIME_FORMAT } from 'apps/fleet-planner/types'
import { TimeFormatInput } from './TimeFormatInput'
import { UserSettingsCard } from './UserSettingsCard'

interface IGeneralDateTimeProps {
  onSubmit: (payload: Types.IUpdateUserSettingsPayload) => void
  timeFormat: SETTINGS_TIME_FORMAT
  errors: string | undefined
}

export const GeneralDateTime: FC<IGeneralDateTimeProps> = ({
  errors,
  onSubmit,
  timeFormat: timeFormatProp,
}) => {
  const { trackEvent } = useFMSAnalytics()
  const [showToastMessage, setShowToastMessage] = useState(false)
  const [timeFormat, setTimeFormat] = useState(timeFormatProp)

  const timeFormatChangeHandler = (value: SETTINGS_TIME_FORMAT) => setTimeFormat(value)

  const closeHandler = () => setShowToastMessage(false)

  const submithandler = () => {
    const payload = {
      settings: {
        timeFormat,
      },
    }
    try {
      onSubmit(payload)
      trackEvent('Settings', 'SAVED_GENERAL_SETTINGS', payload)
      setShowToastMessage(true)
    } catch (e) {
      // no-op
    }
  }

  useEffectOnce(() => trackEvent('Settings', 'VIEWED_GENERAL_SETTINGS'))

  return (
    <>
      <UserSettingsCard title='Date and time'>
        <div className='row'>
          <div className='col-md-6 mt6'>
            <TimeFormatInput value={timeFormat} onChange={timeFormatChangeHandler} />
          </div>
        </div>
        <div className='row fr'>
          <div className='mt4 mb4 pa2'>
            <Button
              data-test='submit-time-format'
              color='primary'
              disabled={timeFormatProp === timeFormat}
              size='large'
              onClick={submithandler}>
              Save Changes
            </Button>
          </div>
        </div>
      </UserSettingsCard>
      <Toast
        open={showToastMessage}
        variation={errors ? 'alert' : 'default'}
        onClose={closeHandler}
        message={errors || 'Changes Saved.'}
      />
    </>
  )
}
